module.exports = __webpack_public_path__ + "img/edc-qBiz.d942d0a2.png";